import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../index';
import { Config } from '../types';

export const useConfig = () => {
  const [data, setData] = useState<Config>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiClient.get<Config>('/api/config');
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch config');
    } finally {
      setLoading(false);
    }
  }, []);

  const updateConfig = useCallback(async (updates: Partial<Config>) => {
    const results: Config = {};
    for (const [key, value] of Object.entries(updates)) {
      if (value !== undefined) {
        await apiClient.put(`/api/config/${key}`, { value });
        results[key] = value;
      }
    }
    setData(prev => ({ ...prev, ...results }));
    return results;
  }, []);

  const getSingleConfig = useCallback(async (key: string) => {
    return data[key] || '';
  }, [data]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return {
    data,
    loading,
    error,
    refetch: fetchConfig,
    updateConfig,
    getSingleConfig,
  };
};